import React from 'react'
import {connect} from 'react-redux'
//import {fetchTowns} from '../actions/townsActions'
import {fetchReportReservations, setReportReservationsInfoText} from '../actions/reportActions'
import { Container, Row, Col, Button, Form, Label, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from 'moment';
//import 'moment/locale/pl';
//import TownsSelect from '../components/TownsSelect'

const mapStateToProps = state => {  
  return {
    filter: state.report.resFilter,    
//    townsFrom: state.towns.allTowns,
//    townsTo: state.towns.toTowns,
//    townFrom: state.towns.fromTown,
//    townTo: state.towns.toTown,
    agentLogin: state.user.agentLogin,
    companies: state.user.agentCompanies,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {  
//    onGetAllTowns: (ownProps) => {          
//      dispatch(fetchTowns(ownProps.agentLogin))
//    },
//    onGetToTowns: (ownProps) => {
//      dispatch(fetchTowns(ownProps.agentLogin, ownProps.townFrom))      
//    },
    onFetchReport: (ownProps, apiRequest) => {
      dispatch(setReportReservationsInfoText("Wyszukiwanie ..."))
      dispatch(fetchReportReservations(apiRequest))      
    },
  }
}
const CR_OPERATION=0
const CR_COURSE=1
const CR_ID=2

const S_CRITERIA = [
  { value: CR_OPERATION, label: 'data operacji', className: 'criteria' },
  { value: CR_COURSE, label: 'data kursu', className: 'criteria' },
  { value: CR_ID, label: 'id/nr', className: 'criteria' },
]

class ReportFilter extends React.Component{
  constructor (props) {
    super(props)  
    
    this.state = {
      formClass: props.formClass || 'filterForm',
      
      agentLogin: props.agentLogin,
      
      criteria: CR_OPERATION,
      idReservation: null,
      fromDate: moment(),
      toDate: moment(),      
      company: null,

      
//      onGetAllTowns: props.onGetAllTowns,
//      onGetToTowns: props.onGetToTowns,
      onFetchReport: props.onFetchReport,
    };
    if (this.props.filter){
      if ('idReservation' in this.props.filter){
        this.state={
          ...this.state,
          criteria: CR_ID,
          idReservation: this.props.filter.idReservation
        }
      }
      else if ('fromDate' in this.props.filter){
        this.state={
          ...this.state,
          criteria: CR_OPERATION,
          fromDate: moment(this.props.filter.dateFrom),
          toDate: moment(this.props.filter.dateTo), 
          calMaxDate: moment(),
        }
      }
      else
        this.state={
          ...this.state,
          criteria: CR_COURSE,
          fromDate: moment(this.props.filter.courseDateFrom),
          toDate: moment(this.props.filter.courseDateTo), 
          calMaxDate: moment().add(6, 'month'),
        }
      if (this.props.filter.company)
        this.state={
          ...this.state,
          company: this.props.filter.company,
        }
    }
    this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
    this.handleChangeToDate = this.handleChangeToDate.bind(this);
    this.handleInputChange=this.handleInputChange.bind(this);
    this.handleChangeCriteria=this.handleChangeCriteria.bind(this)
    this.handleChangeCompany=this.handleChangeCompany.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this); 

    
    //przygotowanie listy przewoźników   
    
  }
  handleChangeCriteria = (selectedOption) => {
    var calMaxDate=this.state.calMaxDate
    switch (selectedOption.value){
      case CR_COURSE:
        calMaxDate=moment().add(6, 'month')
        break;
      case CR_OPERATION:
        calMaxDate=moment()
        break;
      default:
    }
    this.setState({ 
      criteria: selectedOption.value,
      fromDate: ((this.state.fromDate>calMaxDate)?calMaxDate:this.state.fromDate),
      toDate: ((this.state.toDate>calMaxDate)?calMaxDate:this.state.toDate),
      calMaxDate
    });    
  }
  handleChangeCompany = (selectedOption) => {    
    this.setState({ 
      company: (selectedOption ? selectedOption.value : null),
    })
  }
  handleChangeFromDate(date) {
    var toDate=this.state.toDate;
    if (date>toDate)
      toDate=date
    this.setState({
      fromDate: date,
      toDate
    });
  }
  handleChangeToDate(date) {
    var fromDate=this.state.fromDate;
    if (date<fromDate)
      fromDate=date
    this.setState({
      toDate: date,
      fromDate
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    console.log(name + ' -> ' + value);
  }
  
  handleSubmit(event) {
    event.preventDefault();
    this.saveStateToLocalStorage();
    let reportReq={      
      agent: this.props.agentLogin,
    }
    switch (this.state.criteria){
      case CR_OPERATION:
        reportReq={
          ...reportReq,
          dateFrom: this.state.fromDate.format('YYYY-MM-DD'),
          dateTo: this.state.toDate.format('YYYY-MM-DD'),
        }
        if (this.state.company)
          reportReq={...reportReq, company: this.state.company}
        break;
      case CR_COURSE:
        reportReq={
          ...reportReq,
          courseDateFrom: this.state.fromDate.format('YYYY-MM-DD'),
          courseDateTo: this.state.toDate.format('YYYY-MM-DD'),
        }
        if (this.state.company)
          reportReq={...reportReq, company: this.state.company}
        break;
          
      case CR_ID:
        if (this.state.idReservation)
          reportReq={
            ...reportReq,
            idReservation: this.state.idReservation,
          }
        else{
          alert("Nie wprowadzono identyfikatora rezerwacji")
          return;
        }
        break;
        default:
    }
    //console.log("Search Request", searchReq)
    this.state.onFetchReport(this.state, reportReq)
  }
  
  componentDidMount() {
    //fetchTowns(this.state.agentLogin)
    //this.onGetAllTowns()
    //this.state.onGetAllTowns(this.state);
  }
  componentWillUnmount(){
    this.saveStateToLocalStorage();    
  }
  saveStateToLocalStorage(){
//    localStorage.setItem('townFrom', this.state.townFrom);
//    localStorage.setItem('townTo', this.state.townTo);
  }
  
  renderCriteria() {
    return (
      <Col xs="8" sm="3" lg="2">
        <Label>Kryteria wyszukiwania:</Label>
        <Select
          id="state-select"              
          autoFocus
          options={S_CRITERIA}              
          name="criteria"              
          value={this.state.criteria}
          onChange={this.handleChangeCriteria}              
          openOnClick={true}
          searchable={true}
          clearable={false}
        />
      </Col>
    )
  }

  renderId(){    
    if (this.state.criteria === CR_ID)
      return (
        <Col xs="8" sm="3">
          <Label>Id/nr rezerwacji:</Label>
          <Input type="number" 
            value={this.state.qtyNormal} 
            placeholder="Id rezerwacji" 
            name="idReservation"         
            min="0"
            required
            onChange={this.handleInputChange} 
          />
        </Col>
      )
  }
  renderDateFrom() {    
    if (this.state.criteria !== CR_ID)
      return (
        <Col xs="12" sm="3" lg="2">
          <Label>Data początkowa:</Label>
          <DatePicker 
              className="form-control"
              selected={this.state.fromDate}
  //                dateFormat="DD-MM-YYYY"                   
              minDate={moment().add(-6, 'month')}
              maxDate={this.state.calMaxDate}
              onChange={this.handleChangeFromDate}               
          />
        </Col>
      )
  }
  renderDateTo() {    
    if (this.state.criteria !== CR_ID)
      return (
        <Col xs="12" sm="3" lg="2">
          <Label>Data końcowa:</Label>
          <DatePicker 
              className="form-control"
              selected={this.state.toDate}
  //                dateFormat="DD-MM-YYYY"                   
              minDate={moment().add(-12, 'month')}
              maxDate={this.state.calMaxDate}
              onChange={this.handleChangeToDate}               
          />
        </Col>
      )
  }

  renderCompanies() {
    
    if (this.state.criteria !== CR_ID)
      return (
        <Col xs="8" sm="3" lg="2">
          <Label>Przewoźnik:</Label>        
          <Select
            id="state-select"              
            autoFocus
            options={this.props.companies.map(pos => ({value: pos.loginName, label: pos.shortName}))}
            name="criteria"              
            value={this.state.company}
            placeholder="Wybierz przewoźnika"
            onChange={this.handleChangeCompany}              
            openOnClick={true}
            searchable={true}
            clearable={true}
          />
        </Col>
      )    
  }

  render() {
    //console.log(townsFrom, this.state.townsFrom)
    return (  
      <Container fluid={true} className={this.state.formClass}>
      <Form>      
        <Row className="align-items-center">
          {this.renderCriteria()}
          {this.renderId()}
          {this.renderDateFrom()}
          {this.renderDateTo()}
          {this.renderCompanies()} 

          <Col xs="12" sm="auto" className="ml-sm-auto">            
            <Button color="danger" size="lg" onClick={this.handleSubmit}>Szukaj rezerwacji</Button>   
          </Col>
        </Row>          
      </Form>  
      </Container>
    )
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportFilter)    


// WEBPACK FOOTER //
// ./src/containers/ReportResFilter.js